import axios from '../../service/index'
import React from 'react'
import { Button, Upload, message, Modal,Input } from 'antd'
const { TextArea } = Input;
// const qiniuUpUrl = window.location.protocol === "https:" ? 'https://up-z1.qiniup.com' : 'http://up-z1.qiniup.com/';
const qiniuUpUrl = 'https://up-z1.qiniup.com'
class UploadQiniu extends React.Component {
	constructor(props) {
		super(props)
		let fileList = []
		let uploadUrl = null
		let proposalSize = ''
		let accept = ".png,.jpg,.jpeg"
		
		if (props.value) {
			fileList = [props.value] || []
			uploadUrl = props.value.url || ''
		}
		if (props.id === 'swiperUpload') {
			proposalSize = '仅支持jpg/png/jpeg文件，且不超过2M，建议尺寸：1388*520px'
		}
		if (props.id === 'pcSwiperUpload') {
			proposalSize = '仅支持jpg/png/jpeg文件，且不超过2M，建议尺寸：1920*400px'
		}
		if(props.id === 'poster'){
			proposalSize = '仅支持jpg/png/jpeg文件，且不超过2M，建议尺寸：750*426px'
		}
		if (props.id === 'qscode') {
			proposalSize = '仅支持jpg/png/jpeg文件，且不超过2M，建议尺寸：527*937px'
		}
		if (props.id === 'circle') {
			accept = ".png,.jpg,.jpeg,.gif"
			proposalSize = '仅支持jpg/png/jpeg/gif文件，且不超过2M，建议尺寸：700*144px'
		}
		if(props.id === 'posterUrl'){
			accept = '.png,.jpg,.jpeg'
			proposalSize = '为了保证显示效果，请上传比例为16:9的图片 ，支持jpg、jpeg、png格式，文件大小不超过 2M'
		}
		if (props.id === 'uploadUrls') {
			// proposalSize = '仅支持jpg/png/jpeg文件，且不超过2M，建议尺寸：68*68px'
			proposalSize = '为了保证显示效果，请上传 140 x 140 大小的图标，支持jpg、jpeg、png格式，文件大小不超过 2M'
		}
		if (props.id === 'advPic') {
			proposalSize = '仅支持jpg/png/jpeg文件，且不超过2M，建议尺寸：700*266px'
			fileList = [props.value] || []
			uploadUrl = props.value.url || ''
		}
		if (props.id === 'picUrl') {
			proposalSize = '仅支持jpg/png/jpeg文件，且不超过2M，建议尺寸：750*333px;'
		}
		if(props.id === 'surfaceUrl'){
			proposalSize = '支持jpg、jpeg、png格式，文件大小不超过 2M，且最多支持上传8张;'
		}
		if(props.id === 'virtual'|| props.id === 'userNameHead'){
			proposalSize = '支持jpg、jpeg、png格式，文件大小不超过 2M'
		}
		if (props.id === 'coverUrl') {
			proposalSize = '仅支持jpg/png/jpeg文件，且不超过2M，建议尺寸：750*333px;'
		}
		if (props.id === 'worksUrl') {
			proposalSize = '仅支持jpg/png/jpeg文件，建议尺寸：1080*1920px;'
		}
		if (props.id === 'konwledge') {
			proposalSize = '仅支持jpg/png/jpeg文件，建议尺寸：68*68px;'
		}
		if (props.id === 'voteUrl') {
			accept = ".png,.jpg,.jpeg,.gif"
			proposalSize = '仅支持jpg/png/jpeg/gif文件，且不超过2M'
		}
		if(props.id === 'courseUrl'){
			accept = ".png,.jpg,.jpeg"
			proposalSize = '为了保证显示效果，请上传比例为16:9的图片 ，支持jpg、jpeg、png格式，文件大小不超过 2M'
		}
		if(props.id === 'qslcode'){
			proposalSize = '为了保证显示效果，请上传 1080 x1920 大小的图片，支持jpg、jpeg、png格式，文件大小不超过 2M'
		}
		if(props.id === 'classifyIcon'){
			proposalSize = '为了保证显示效果，请上传 140 x140 大小的图片，支持jpg、jpeg、png格式，文件大小不超过 2M'
		}
		this.state = {
			visible: false,
			bosObj: null,
			fileType: 'limit',
			scriptStatus: 'no',
			fileList: fileList,
			token: '',
			url: '',
			uploadUrl: uploadUrl,
			previewVisible: false,
			type: '',
			proposalSize: proposalSize,
			accept: accept,
		}
	}
	handleOk() {
		this.setState({ visible: false })
	}
	componentDidMount() {
		this.getToken()
	}
	static getDerivedStateFromProps(nextProps, prevState) {
		if (prevState.fileList.length<=0&&nextProps.value?.url) {
			let fileList = []
			let uploadUrl = ''
			fileList = [nextProps.value] || []
			uploadUrl = nextProps.value?.url || ''
			// this.setState({fileList, uploadUrl})
			return {fileList,uploadUrl }
		}
		return null;
	}
	getToken() {
		let _this = this;
		axios.get("/uplodController/get7menrToken").then((res) => {
			if (res.data.code === '200') {
				_this.setState({
					token: res.data.data.token,
					url: res.data.data.url
				})
				this.props.getQiniuUrl(res.data.data.url)
			} else {
				message.error('七牛token获取失败')
			}

		}).catch((e) => {
			console.log(e)
		})
	}
	handlePreview = async file => {
		this.setState({
			previewVisible: true,
		});
	}
	removeFileList = () => {
    this.setState({
      uploadUrl: "",
    });
    this.setState({ fileList: [] }, () => {
    });
  };
	handleChange = ({ file, fileList }) => {
		if (file.percent === 100) {
			if (file.status === 'done') {

				file.type = this.state.type
				this.setState({
					uploadUrl: this.state.url + '/' + file.response.key
				})
				let fileL = {
					uid: fileList[0].uid,
					name: fileList[0].name,
					status: fileList[0].status,
					url: this.state.url + '/' + fileList[0].response.hash,
					type: fileList[0].type
				}
				this.setState({ fileList: [fileL] });
				console.log(file)
				this.props.onChange(file)
			}
		}
		else if (file.status === 'removed') {
			this.setState({ fileList: [] },()=> {
				this.props.onChange()
			});
			
		}
	};
	showModal() {
		this.setState({ visible: true })
	}
	handleCancel = () => this.setState({ previewVisible: false });
	render() {
		// const  isURL  = this.props.isURL
		const { fileList, previewVisible, uploadUrl, accept } = this.state;
		const uploadButton = (
			<div>
				<Button>上传</Button>
			</div>
		);
		return (
			<div>
				<Upload
					accept={accept}
					action={qiniuUpUrl}
					fileList={fileList}
					listType='picture'
					beforeUpload={(file, fileList) => {
						this.setState({ type: file.type })
						const isLt10M = file.size / 1024 / 1024 <= 2;
						if (!isLt10M) {
							message.error("文件大小限制在2M以下！");
							return false;
						}
						this.setState({ fileList: fileList })
					}}

					onPreview={this.handlePreview}
					onChange={this.handleChange}
					onRemove={(file, fileList) => {
						this.setState({
							uploadUrl:""
						})
						// if (file.status === "removed") {
							// console.log('removed2')
							this.setState({fileList:[]},()=> {
								this.props.onChange()
							})
							// }

					}}
					data={{ token: this.state.token }}
				>
					{this.state.fileList.length >= 1 ? '' : uploadButton}
					
				</Upload>
				<p style={{ fontSize: '12px', color: '#999999' }}>{this.state.proposalSize}</p>
				<Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
					<img alt="example" style={{ width: '100%' }} src={uploadUrl} />
				</Modal>
				{ this.props.isURL ? <TextArea autoSize value={uploadUrl}/> : "" }
			</div>
		)
	}
}

export default UploadQiniu
